var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"popup"},[_c('a',{staticClass:"popup-closer",attrs:{"href":"#","id":"popup-closer"},on:{"click":_vm.onClose}}),_c('div',{staticClass:"popup-content",attrs:{"id":"popup-content"}},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }